import * as React from 'react';
import { Box } from '@packages/ui';
import { Flex } from '@packages/ui';
import { StyledTitle, StyledInnerWrapper, FilterCTAButton } from './FilterSliderStyleComponents';
import { SmartLink } from '../../SmartLink';
import { DYSliderCTAButton } from './DYFilterSlider';

export interface FilterSliderProps {
  onClick: VoidFunction;
  ctas: DYSliderCTAButton[];
  title: string;
  titleColor: string;
}

export const FilterSlider: React.FC<FilterSliderProps> = ({ ctas, title, titleColor, onClick }) => {
  return (
    <Flex flexDirection={'column'}>
      <StyledTitle color={titleColor}>{title}</StyledTitle>
      {ctas.length > 0 && (
        <StyledInnerWrapper>
          {ctas.map(({ text, linkOrQuery }, idx) => {
            if (!text?.trim()) {
              return <></>;
            }

            return (
              <Box key={idx} ml={idx > 0 ? 2 : 0} onClick={onClick} data-testid="filter-slider-cta">
                <SmartLink linkUrl={linkOrQuery} target="_self">
                  <FilterCTAButton px={3} variant="tag" block={false} noShadow={false}>
                    {text}
                  </FilterCTAButton>
                </SmartLink>
              </Box>
            );
          })}
        </StyledInnerWrapper>
      )}
    </Flex>
  );
};
